module.exports = __webpack_public_path__ + "img/daishenhe.545ffdec.png";